module.exports = __webpack_public_path__ + "img/logotipo.96f3b717.svg";